/* import __COLOCATED_TEMPLATE__ from './diy-invoice-analytics.hbs'; */
import { capitalize } from '@ember/string';
import EmberObject, { computed } from '@ember/object';
import DiyBaseAnalytics from './diy-base-analytics';
import ICON_PATH from '../../../constants/assets/icons';

const DATE = 'triggeredAt';
const COST = 'amount';
const INVOICE_NUMBER = 'id';

const COST_CODES = 'costCodes';
const STORY_CODES = 'storyCodes';

const DESCRIPTION = 'description';
const CURRENT_STATUS = 'currentStatus';

const AVAILABLE_STATUS = [
  'Paid',
  'Due',
  'Overdue'
];

const MIN_COST = 1250;
const MAX_COST = 9000;

const COST_CODE_LABELS = [
  '',
  'Social Media',
  'Brand Creative - US',
  'Brand Creative - Global'
];

const STORY_CODE_LABELS = [
  '',
  'Social Media',
  'Brand Creative - US',
  'Brand Creative - Global'
];
const NUMBER_OF_INVOICES = 16;
const INVOICE_START_NUMBER = 7551;
const PROJECT_START_NUMBER = 5023;
const MIN_DATE = new Date(2017, 9, 1);
const MAX_DATE = new Date();

function randomDate() {
  return new Date(MIN_DATE.getTime() + Math.random() * (MAX_DATE.getTime() - MIN_DATE.getTime()));
}

function randomStatus() {
  // bobo weighted random method to favor lower index statuses
  const idx = Math.floor(Math.pow(Math.random(), 2) * AVAILABLE_STATUS.length);
  return AVAILABLE_STATUS[idx];
}

export default DiyBaseAnalytics.extend({
  title: 'Unlock your invoices',
  text: 'View your billing and payments reporting in one place by upgrading to a subscription plan.',
  icon: ICON_PATH.INVOICE_REPORT,

  // the analytics table widget needs a filter array
  filters: [],

  init() {
    this._super(...arguments);
    const invoices = [];
    for (let i = 0; i < NUMBER_OF_INVOICES; i++) {
      invoices.push({
        [DATE]: randomDate(),
        [CURRENT_STATUS]: randomStatus(),
        [COST_CODES]: [COST_CODE_LABELS[Math.floor(Math.random() * COST_CODE_LABELS.length)]],
        [STORY_CODES]: [STORY_CODE_LABELS[Math.floor(Math.random() * STORY_CODE_LABELS.length)]],
        [COST]: Math.random() * (MAX_COST - MIN_COST) + MIN_COST,
      });
    }
    invoices.sort((a, b) => a[DATE] - b[DATE]);
    let invoiceId = INVOICE_START_NUMBER;
    let projectId = PROJECT_START_NUMBER;

    const invoiceObjects = invoices.map(invoice => {
      invoice[INVOICE_NUMBER] = invoiceId;
      invoice[DESCRIPTION] = `Project #${projectId}`;
      // increment the ids by a random amount for our next invoice
      invoiceId += Math.floor(Math.random() * 100 + 20);
      projectId += Math.floor(Math.random() * 100 + 20);

      return EmberObject.create(invoice);
    });

    this.set('data', invoiceObjects);
  },

  ///////////
  // TABLE //
  ///////////
  tableColumns: computed('usesCostCodes', function() {
    const formatMoney = this.formatMoney.bind(this);
    const formatDate = this.formatDate.bind(this);
    const formatArray = this.formatArray.bind(this);
    let columns = [
      {
        label: 'Invoice #',
        param: INVOICE_NUMBER,
        display: id => `#${id}`,
        sortFunction: (a, b) => parseInt(b) - parseInt(a)
      },
      {
        label: 'Date',
        param: DATE,
        display: formatDate,
        sortDescending: true,
        defaultSort: true,
      },
      {
        label: 'Cost Codes',
        param: COST_CODES,
        display: formatArray
      },
      {
        label: 'Story Codes',
        param: STORY_CODES,
        display: formatArray
      },
      {
        label: 'Project',
        param: DESCRIPTION,
        wide: true,
      },
      {
        label: 'Amount ($USD)',
        param: COST,
        display: formatMoney
      },
      {
        label: 'Payment Status',
        param: CURRENT_STATUS,
        display: status => capitalize(String(status))
      },
      {
        param: INVOICE_NUMBER,
        icon: 'file_download',
        action: () => null
      }
    ];

    return columns;
  }),
});
